module.exports = __webpack_public_path__ + "static/media/Members.c7e12f10.svg";